import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import ErrorFeedback from './component';

import { setErrorModalClosed } from 'redux/modules/error-handler/duck.js';
import { getIsOpened, getTitle, getDescription } from 'redux/modules/error-handler/selectors';

const actionCreators = {
  setErrorModalClosed,
};

const enhance = compose(
  connect((state) => {
    return {
      show: getIsOpened(state),
      title: getTitle(state),
      description: getDescription(state),
    };
  }, actionCreators),
  withHandlers({
    handleCloseModal:
      ({ setErrorModalClosed }) =>
      () => {
        setErrorModalClosed();
      },
  })
);

export default enhance(ErrorFeedback);
